import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages = defineMessages({
	switchSiteLabel: {
		id: 'twg-microsite.siteSwitcher.switchSiteLabel',
		defaultMessage: 'Switch site',
		description: 'Accessible label and tooltip for the site switcher trigger button',
	},
	switchSiteHeading: {
		id: 'twg-microsite.siteSwitcher.switchSiteHeading',
		defaultMessage: 'Switch site',
		description: 'Heading shown at the top of the site switcher dropdown menu',
	},
} as const) satisfies Record<string, MessageDescriptor>;
